import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListPointMechanisms = createAsyncThunk(
  "pointMechanisms/getListPointMechanisms",
  async ({ currentPage, pageSize, branchId }, { rejectWithValue }) => {
    try {
      let apiUrl = `/api/v1/serviceconnect/point_mechanisms?has_paginate&size=${pageSize}&page=${currentPage}`;
      if (branchId) { // Nếu chỉ có branchId
        apiUrl += `&branch_first_id=${branchId}`;
      }

      const response = await http.get(apiUrl);
      
      return response.data;
    } catch (error) {
      return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

export const createPointMechanisms = createAsyncThunk(
  "pointMechanisms/createPointMechanisms",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/point_mechanisms`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updatePointMechanisms = createAsyncThunk(
  "pointMechanisms/updatePointMechanisms", // Đổi tên hành động cho phù hợp
  async ({ id, data }, { rejectWithValue }) => { // Lấy đối tượng có `id` và `data`
    try {
      const response = await http.put(`/api/v1/serviceconnect/point_mechanisms/${id}`, data); // Gọi API PUT
      return response.data; // Trả về kết quả thành công
    } catch (error) {
      return rejectWithValue(error.response.data); // Trả về lỗi nếu có
    }
  }
);

export const deletePointMechanisms = createAsyncThunk(
  "pointMechanisms/deletePointMechanisms",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/api/v1/serviceconnect/point_mechanisms/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);